import Vue from 'vue';
// 引入资源请求插件
import axios from 'axios';
import store from '../store';
import router from '../router';

// 使用axios
Vue.prototype.$axios = axios;

// 设置全局axios默认值
// axios.defaults.timeout = 5000; // 5000的超时验证
axios.defaults.headers.post['Content-Type'] = 'application/json:charset=UTF-8';

// 全局默认配置
axios.defaults.headers.common['Authorization'] = 'BasicAuth ' + store.state.token;

// axios.defaults.withCredentials = true;

axios.defaults.baseURL = process.env.URL_ROOT;

// 添加请求拦截器
// axios携带cookie
const instance = axios.create({
  // headers: {Authorization: `BasicAuth ${store.state.token}`},
  baseURL: process.env.URL_ROOT
  // withCredentials: true
});

instance.interceptors.request.use(config => {
  // baseUrl: process.env.URL_ROOT
});

// http request 拦截器
axios.interceptors.request.use(
  config => {
    // 在发送请求前做些什么
    // 判断是否存在token，如果存在将每个页面header都添加token
    if (store.state.token) {
      config.headers.Authorization = `BasicAuth ${store.state.token}`;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  err => {
    if (err.response) {
      switch (err.response.status) {
        case 401:
          store.commit('delToken');
          router.replace({
            path: '/home/lto'
          });
          break;
        case 403:
          alert('您没有访问操作此功能的权限，请联系管理员！');
          break;
        case 500:
          alert('500信息请求错误,请联系管理员');
          break;
      }
    }
    // return err.response;
  }
);

export default ({

})



// WEBPACK FOOTER //
// ./src/axios/index.js